var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "content-overlay sub-plan" }, [
    _c(
      "div",
      {
        staticClass: "in-content",
        class: { clsng: _vm.Global.tempSubClosingOverlay },
      },
      [
        _c("div", { staticClass: "head" }, [
          _c(
            "span",
            {
              staticClass: "x",
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.closeSubOverlay.apply(null, arguments)
                },
              },
            },
            [
              _c(
                "svg",
                {
                  attrs: {
                    width: "22",
                    height: "22",
                    viewBox: "0 0 22 22",
                    fill: "none",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M19.4706 2.5L2.5 19.4706",
                      stroke: "white",
                      "stroke-width": "3",
                      "stroke-linecap": "square",
                    },
                  }),
                  _vm._v(" "),
                  _c("path", {
                    attrs: {
                      d: "M19.4706 19.4706L2.5 2.5",
                      stroke: "white",
                      "stroke-width": "3",
                      "stroke-linecap": "square",
                    },
                  }),
                ]
              ),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("PlanCard", { attrs: { plan: _vm.Global.plans[1] } }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }